import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function GenerativeAiPreferenceTooltip() {
    return (
        <div className="generative-ai-tooltip">
            <FormattedMessage id="generative_ai_tooltip" />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/GenerativeAiPreferenceTooltip.js